import JottaTerms from '@jotta/config/JottaTerms'
import { getDetectedLocale } from '@jotta/i18n/locale'

import { ProseContainer } from '../components/ProseContainer'

export function JottaTermsAndConditions() {
  const locale = getDetectedLocale()
  const termsHtml = locale in JottaTerms ? JottaTerms[locale] : JottaTerms.en
  return (
    <ProseContainer>
      <div
        // Trusted static terms HTML from @jotta/config.
        // oxlint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: termsHtml,
        }}
      />
    </ProseContainer>
  )
}
